import insight1 from "../assets/insight-1.png";
import insight2 from "../assets/insight-2.png";
import insight3 from "../assets/insight-3.png";
import insight4 from "../assets/insight-4.png";
import "./container.css";
import "./SmartMoneyInsights.css";

const INSIGHTS = [
  {
    image: insight1,
    alt: "Debt management planner with EMI notes and calculator",
    category: "Debt Management",
    titleLines: ["How to Reduce Multiple", "EMIs Without Hurting", "Your Budget"],
    descLines: [
      "Struggling with multiple",
      "payments? Learn practical ways to",
      "combine and manage your EMIs smarter",
      "without financial strain.",
    ],
  },
  {
    image: insight2,
    alt: "Financial planning notebook with cash flow chart",
    category: "Financial planning",
    titleLines: ["5 Smart Ways to Take", "Control of Your Monthly", "Cash Flow"],
    descLines: [
      "From tracking expenses to",
      "optimizing repayments — simple",
      "strategies that can make a big",
      "difference.",
    ],
  },
  {
    image: insight3,
    alt: "Credit score dashboard showing a score of 785",
    category: "Credit score",
    titleLines: ["How Debt Consolidation", "Impacts Your Credit", "Score"],
    descLines: [
      "Understand the short-term and",
      "long-term effects of",
      "consolidating your debt and how",
      "it can improve your financial",
      "health.",
    ],
  },
  {
    image: insight4,
    alt: "Digital lending app on a phone with a bank icon",
    category: "Industry Insights",
    titleLines: ["Why Indians Are", "Choosing Digital Lending", "Platforms"],
    descLines: [
      "Explore the shift towards faster,",
      "paperless lending and what it",
      "means for borrowers today.",
    ],
  },
];

const SmartMoneyInsights = () => {
  return (
    <section className="insights-section w-full">
      <div className="container-8xl">
        <h2
          className="insights-heading"
          style={{ color: "#000", fontStyle: "normal", fontWeight: 500, fontFamily: "Inter" }}
        >
          Smart Money Insights
        </h2>
        <p
          className="insights-subtext"
          style={{ fontStyle: "normal", fontWeight: 400, fontFamily: "Inter" }}
        >
          Money advice made simple, practical, and easy to act on.
        </p>

        <div className="insights-cards">
          {INSIGHTS.map((insight) => (
            <div key={insight.category} className="insight-card">
              <img src={insight.image} alt={insight.alt} className="insight-card-image" />

              <span
                className="insight-card-category"
                style={{ color: "#283AAA", fontWeight: 700, fontStyle: "normal", fontFamily: "Inter" }}
              >
                {insight.category}
              </span>

              <h3
                className="insight-card-title"
                style={{ color: "#434347", fontFamily: "Inter", fontWeight: 500, fontStyle: "normal" }}
              >
                {insight.titleLines.map((line, index) => (
                  <span key={line} style={{ whiteSpace: "nowrap" }}>
                    {line}
                    {index < insight.titleLines.length - 1 && <br />}
                  </span>
                ))}
              </h3>

              <p
                className="insight-card-desc"
                style={{ color: "#5A5A60", fontFamily: "Inter", fontWeight: 400, fontStyle: "normal" }}
              >
                {insight.descLines.map((line, index) => (
                  <span key={line} style={{ whiteSpace: "nowrap" }}>
                    {line}
                    {index < insight.descLines.length - 1 && <br />}
                  </span>
                ))}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SmartMoneyInsights;
